"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortKeysByTreeOrder = exports.getRCMLeafKeys = exports.findLeafNodes = exports.getCheckedLeaf = exports.collapseTree = exports.expandTree = void 0;
var lodash_1 = __importDefault(require("lodash"));
function getExpandLevels(data, expandedKeys) {
    var level = lodash_1.default.max(lodash_1.default.map(data, function (item) {
        if (lodash_1.default.includes(expandedKeys, item.key) && item.children) {
            return getExpandLevels(item.children, expandedKeys) + 1;
        }
        return 0;
    }));
    return level || 0;
}
function getKeysUntilLevel(data, level) {
    if (level <= 0) {
        return [];
    }
    var keys = Array(0);
    lodash_1.default.forEach(data, function (item) {
        keys.push(item.key);
        if (item.children) {
            keys.push.apply(keys, getKeysUntilLevel(item.children, level - 1));
        }
    });
    return keys;
}
function expandTree(data, expandedKeys) {
    var level = getExpandLevels(data, expandedKeys);
    return getKeysUntilLevel(data, level + 1);
}
exports.expandTree = expandTree;
function collapseTree(data, expandedKeys) {
    var level = getExpandLevels(data, expandedKeys);
    return getKeysUntilLevel(data, level - 1);
}
exports.collapseTree = collapseTree;
function getCheckedLeaf(dataNodes, checked) {
    var getCheckedLeafInner = function (items, checkedIds) {
        var ids = [];
        lodash_1.default.forEach(items, function (item) {
            if (item.children && !lodash_1.default.isEmpty(item.children)) {
                ids.push.apply(ids, getCheckedLeafInner(item.children, checkedIds));
            }
            else if (lodash_1.default.includes(checkedIds, item.key)) {
                ids.push(item.key);
            }
        });
        return ids;
    };
    var ids = [];
    lodash_1.default.forEach(checked, function (item) {
        if (typeof item !== 'string') {
            // eslint-disable-next-line no-console
            console.log('Wrong id type');
            return;
        }
        ids.push(item);
    });
    return getCheckedLeafInner(dataNodes, ids);
}
exports.getCheckedLeaf = getCheckedLeaf;
function findLeafNodes(data, ids) {
    var newData = [];
    lodash_1.default.forEach(data, function (item) {
        if (lodash_1.default.includes(ids, item.id)) {
            newData.push(item);
        }
        else if (item.children) {
            newData.push.apply(newData, findLeafNodes(item.children, ids));
        }
    });
    return newData;
}
exports.findLeafNodes = findLeafNodes;
function getRCMLeafKeys(data) {
    var keys = [];
    lodash_1.default.forEach(data, function (item) {
        if (item.type === 'process' || item.type === 'risk' || item.type === 'control') {
            keys.push(item.key);
        }
        else if (item.children) {
            keys.push.apply(keys, getRCMLeafKeys(item.children));
        }
    });
    return keys;
}
exports.getRCMLeafKeys = getRCMLeafKeys;
function sortKeysByTreeOrder(treeData, keys) {
    var newKeys = [];
    lodash_1.default.forEach(treeData, function (item) {
        if (item.id && lodash_1.default.includes(keys, item.key)) {
            newKeys.push(item.key);
        }
        else if (item.children) {
            newKeys.push.apply(newKeys, sortKeysByTreeOrder(item.children, keys));
        }
    });
    return newKeys;
}
exports.sortKeysByTreeOrder = sortKeysByTreeOrder;
// export function sortLeafKeys(keys: string[]): void {
//   keys.sort((a, b): number => {
//     const indexA = a.indexOf('/')
//     const indexB = b.indexOf('/')
//     if (indexA === -1 && indexB === -1) {
//       return a < b ? -1 : a > b ? 1 : 0
//     } else if (indexA === -1) {
//       return -1
//     } else if (indexB === -1) {
//       return 1
//     }
//     const treeKeyA = a.slice(0, indexA)
//     const treeKeyB = b.slice(0, indexB)
//     if (treeKeyA !== treeKeyB) {
//       const levelsA = treeKeyA.split('-')
//       const levelsB = treeKeyB.split('-')
//       let i = 0
//       do {
//         if (levelsA[i] !== levelsB[i]) {
//           return parseInt(levelsA[i]) - parseInt(levelsB[i])
//         }
//         i += 1
//         if (i === levelsA.length) {
//           return -1
//         } else if (i === levelsB.length) {
//           return 1
//         }
//       } while (i < levelsA.length && i < levelsB.length)
//     }
//     const idA = a.slice(indexA + 1)
//     const idB = b.slice(indexB + 1)
//     return idA < idB ? -1 : idA > idB ? 1 : 0
//   })
// }
// export function sliceTreeId(allIds: string[], treeId: string): string | undefined {
//   const index = treeId.indexOf('/')
//   if (index !== -1) {
//     const id = treeId.slice(index + 1)
//     if (_.includes(allIds, id)) {
//       return id
//     }
//   }
//   return undefined
// }
//# sourceMappingURL=TreeUtils.js.map